export class WebRTCCheck {
    static checkWebRTCSupported() {
        // Source: https://blog.ivrpowers.com/post/coding/browser-webrtc/
        // Alternative: https://github.com/muaz-khan/DetectRTC
        // However, we are not doing any audio or video, so keep it simple.
        return navigator.getUserMedia ||
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.msGetUserMedia ||
            window.RTCPeerConnection;
    }
    static isIOS() {
        // https://stackoverflow.com/a/58065241/9370196
        return (/iPad|iPhone|iPod/.test(navigator.platform) ||
            (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) &&
            !window.MSStream;
    }
}
//# sourceMappingURL=web-rtc-check.js.map